/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

/**
 * @namespace Phaser.Physics
 */

module.exports = {

    Arcade: require('./arcade'),
    Impact: require('./impact'),
    Matter: require('./matter-js')

};



//////////////////
// WEBPACK FOOTER
// ./physics/index.js
// module id = 853
// module chunks = 0